module.exports = __webpack_public_path__ + "img/empty-state.7a16b47f.png";